import { useMemo } from 'react';
import { ConfigService } from '../services/config.service';

/**
 * Hook to access feature flags in React components
 * @returns Object with feature flag utilities
 */
export function useFeatureFlags() {
  const flags = useMemo(() => ConfigService.getFeatureFlags(), []);

  return {
    /**
     * All available feature flags
     */
    flags,
    
    /**
     * Check if a specific feature flag is enabled
     * @param flagName - The name of the feature flag
     * @returns True if the feature flag is enabled
     */
    isEnabled: (flagName: string) => ConfigService.isFeatureEnabled(flagName),
    
    /**
     * Get a specific feature flag value
     * @param flagName - The name of the feature flag
     * @returns The boolean value of the feature flag
     */
    getFlag: (flagName: string) => ConfigService.getFeatureFlag(flagName),
  };
}

/**
 * Hook to check a specific feature flag
 * @param flagName - The name of the feature flag to check
 * @returns True if the feature flag is enabled
 */
export function useFeatureFlag(flagName: string): boolean {
  return useMemo(() => ConfigService.isFeatureEnabled(flagName), [flagName]);
}
